import { createSlice } from "@reduxjs/toolkit";

const wishlistSlice = createSlice({
  name: "wishlist",
  initialState: [],
  reducers: {
    addToWishlist: (state, action) => {
      state.push(action.payload);
    },
    removeFromWishlist: (state, action) => {
      const projectIdToRemove = action.payload.id;
      const updatedWishlist = state.filter(
        (item) => item._id !== projectIdToRemove
      );
      return updatedWishlist;
    },
    setToWishlist: (state, action) => {
      return action.payload;
    },
    clearWishlist: (state) => {
      return [];
    },
  },
});

export const { addToWishlist, removeFromWishlist, setToWishlist ,clearWishlist } =
  wishlistSlice.actions;

export default wishlistSlice.reducer;
